/**
 * Slug を正規化してエンコードする。
 * Next.js の params.slug がエンコードされた状態で渡される場合があるため、
 * 一度デコードしてから再エンコードして二重エンコードを防ぐ。
 */
export function encodeSlug(slug: string): string {
  let decoded: string;
  try {
    decoded = decodeURIComponent(slug);
  } catch {
    // 無効なエンコードの場合はそのまま使用
    decoded = slug;
  }
  return encodeURIComponent(decoded);
}
